import { watch } from 'vue'
import { dateService, FORMATS } from '@/global/services/date'

// Picking a start that lands after the current end makes the end meaningless
// (and confusing to leave on screen) — clearing it is simpler than blocking
// the pick itself, and lets the user just re-pick a valid end afterwards.
export function useDateRangeGuard (target, startKey, endKey, fmt = FORMATS.datetimeShort) {
  watch(() => target?.[startKey], (start) => {
    const end = target?.[endKey]
    if (!target || !start || !end) {
      return
    }
    if (dateService.isAfter(start, end, fmt)) {
      target[endKey] = ''
    }
  })
}
